import Circles from '../Circles/Circles';

import './header.scss';

const Header = () => {
    return (
        <header className="header">
            <Circles />
        </header>
    )
}

export default Header